<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 加工詳細画面 -->
      <div class="process1DataForm">
        <t-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleClick"
        >
          <t-tab-pane
            :key="item.name"
            v-for="item in editableTabs"
            :label="item.title"
            :name="item.name"
            :disabled="item.disabled"
          >
            <div style="margin: 10px">
              <t-table
                ref="item.tableData"
                :data="item.tableData"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :row-class-name="rowClassName"
                :cell-class-name="tableCellClassName"
                :height="detailHeight"
                border
                fit
              >
                <t-table-column
                  v-for="(column, index) in filteredColumnsByTab"
                  :key="column.prop || index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>

                <t-table-column
                  v-for="(column, index) in item.tableColumns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <template
                    v-if="column.children && column.children.length > 0"
                  >
                    <t-table-column
                      v-for="(columnSon, indexSon) in column.children"
                      :key="indexSon"
                      :type="columnSon.type"
                      :prop="columnSon.prop"
                      :label="columnSon.label"
                      :min-width="columnSon.width"
                      :class-name="columnSon.class"
                      :overflowTooltip="columnSon.overflowTooltip"
                    >
                    </t-table-column>
                  </template>
                </t-table-column>
              </t-table>
            </div>
          </t-tab-pane>
        </t-tabs>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  getCommonInfoList,
  searchOrderInfoFromAcceptInfo,
} from "@/services/acceptOrder";
import {
  formatCurrencyToNumber,
  formatDateStrToString,
  formatStringToCurrency,
  formatStringToWeight,
  getDialogContentHeight,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  FACTORY_KBN_DALIAN,
  NORMAL_PROD,
  STR_AOB_ORDER_STATUS_NOT_ORDERED,
  STR_AOB_ORDER_STATUS_ORDERED,
  STR_EMPTY,
  STR_ONE,
  STR_THREE,
  STR_ZERO,
} from "@/utils/const";
import { Message } from "@tellus/component";
//import { setColumnWidth } from "@/utils/table";
export default {
  computed: {},

  data() {
    return {
      //明細情報のheight
      detailHeight: getDialogContentHeight(window.innerHeight, 0, 0, 90),

      activeName: "order",

      //仕入先リスト
      supplierCpyList: [],

      //製品異常区分リスト
      prodExKbnList: [],

      localDisabled: false,

      editableTabs: [
        {
          title: t("resource.ACCEPT_ORDER.ORDER"),
          name: "order",
          disabled: false,
          tableData: [],
          tableColumns: [
            // 仕入先
            {
              prop: "aodSupCodeAbb",
              label: t("resource.COMMON_CONSTANT.SUPPLIER"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            // 仕入先納期
            {
              prop: "aodSupDate",
              label: t("resource.ACCEPT_ORDER.SUPPLIER_DELIVERY_DATE"),
              width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
              class: "cell_txt_center",
            },

            //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
            // 加工単価(CNY)
            {
              prop: "aodUPriceCNY",
              label: t("resource.ACCEPT_ORDER.PROCESS_U_PRICE_CNY"),
              width: t("widgetSize.ORDER.DETIAL_LABEL_WIDTH"),
              class: "cell_txt_right",
            },
            //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

            // 仕入価格(個)/加工単価
            {
              prop: "aodUPrice",
              label: t("resource.ACCEPT_ORDER.PROCESS_U_PRICE"),
              width: t("widgetSize.ORDER.DETIAL_LABEL_WIDTH"),
              class: "cell_txt_right",
            },

            //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
            // 小計仕入金額(CNY)
            {
              prop: "aodTotPriceCNY",
              label: t("resource.ACCEPT_ORDER.PURCHASE_TOTAL_CNY"),
              width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
              class: "cell_txt_right",
            },
            //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

            // 小計仕入金額
            {
              prop: "aodTotPrice",
              label: t("resource.ACCEPT_ORDER.PURCHASE_TOTAL"),
              width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
              class: "cell_txt_right",
            },

            //注文状態
            {
              prop: "aodOrderStatus",
              label: t("resource.ACCEPT_ORDER.ORDER_STATUS"),
              width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
              class: "cell_txt_center",
            },
          ],
        },
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 受注詳細：検査室入荷情報を表示しない
        // {
        //   title: t("resource.ACCEPT_ORDER.CHECK_RECEIVE"),
        //   name: "checkRece",
        //   disabled: false,
        //   tableData: [],
        //   tableColumns: [
        //     {
        //       label: t("resource.ACCEPT_ORDER.RECEIVE_COUNT"),
        //       children: [
        //         // 合計
        //         {
        //           prop: "okSumQty",
        //           label: t("resource.ACCEPT_ORDER.SUM"),
        //           width: t("widgetSize.tableCommon.defaultWidth"),
        //           class: "cell_txt_right",
        //         },
        //         // 残
        //         {
        //           prop: "residueSumQty",
        //           label: t("resource.ACCEPT_ORDER.RESIDUE"),
        //           width: t("widgetSize.tableCommon.defaultWidth"),
        //           class: "cell_txt_right",
        //         },
        //       ],
        //     },
        //   ],
        // },
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        {
          title: t("resource.ACCEPT_ORDER.TRANSPORT"),
          name: "trans",
          disabled: false,
          tableData: [],
          tableColumns: [
            {
              label: t("resource.ACCEPT_ORDER.TRANS_COUNT"),
              children: [
                // 済み
                {
                  prop: "okSumQty",
                  label: t("resource.ACCEPT_ORDER.DONE"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
                // 運送中
                // {
                //   prop: "ingSumQty",
                //   label: t("resource.ACCEPT_ORDER.TRANSPORTING"),
                //   width: t("widgetSize.tableCommon.defaultWidth"),
                //   class: "cell_txt_right",
                // },
                // 残
                {
                  prop: "residueSumQty",
                  label: t("resource.ACCEPT_ORDER.RESIDUE"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
              ],
            },
          ],
        },
        {
          title: t("resource.ACCEPT_ORDER.OFFICERCVING"),
          name: "rece",
          disabled: false,
          tableData: [],
          tableColumns: [
            {
              label: t("resource.ACCEPT_ORDER.RECEIVE_COUNT"),
              children: [
                // 合計
                {
                  prop: "okSumQty",
                  label: t("resource.ACCEPT_ORDER.SUM"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
                // 残
                {
                  prop: "residueSumQty",
                  label: t("resource.ACCEPT_ORDER.RESIDUE"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
              ],
            },
          ],
        },
        {
          title: t("resource.ACCEPT_ORDER.OUTBOUND"),
          name: "send",
          disabled: false,
          tableData: [],
          tableColumns: [
            {
              label: t("resource.ACCEPT_ORDER.OUTBOUND_COUNT"),
              children: [
                // 合計
                {
                  prop: "okSumQty",
                  label: t("resource.ACCEPT_ORDER.SUM"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
                // 残
                {
                  prop: "residueSumQty",
                  label: t("resource.ACCEPT_ORDER.RESIDUE"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
              ],
            },
          ],
        },
        {
          title: t("resource.ACCEPT_ORDER.REQUEST"),
          name: "request",
          disabled: false,
          tableData: [],
          tableColumns: [
            // 売価(個)
            {
              prop: "aodUSetPrice",
              label: t("resource.ACCEPT_ORDER.SALES_U_PRICE"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
            // 合計
            {
              prop: "aodTotSalesPrice",
              label: t("resource.ACCEPT_ORDER.AMOUNT_SUM"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
            {
              label: t("resource.ACCEPT_ORDER.REQUESTED"),
              children: [
                // 数量
                {
                  prop: "requestedSumQty",
                  label: t("resource.ACCEPT_ORDER.COUNT"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
                // 合計
                {
                  prop: "requestedTotalPrice",
                  label: t("resource.ACCEPT_ORDER.AMOUNT_SUM"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
              ],
            },
            {
              label: t("resource.ACCEPT_ORDER.REQUEST_REDISUE"),
              children: [
                // 数量
                {
                  prop: "requestResidueSumQty",
                  label: t("resource.ACCEPT_ORDER.COUNT"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
                // 合計
                {
                  prop: "requestResidueTotalPrice",
                  label: t("resource.ACCEPT_ORDER.AMOUNT_SUM"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  class: "cell_txt_right",
                },
              ],
            },
          ],
        },
      ],

      commonColumns: [
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 数量
        {
          prop: "aodProdQuantity",
          label: t("resource.COMMON_CONSTANT.COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.COMMON_CONSTANT.UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // クローズ
        {
          prop: "aodReduceKbn",
          label: t("resource.DUE_DATE_EDIT.BTN_PROD_CLOSE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // 製品区分
        {
          prop: "aodProdExKbnVal",
          label: t("resource.ACCEPT_ORDER.PROD_EX_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // 異常提出日
        {
          prop: "aodProdExDate",
          label: t("resource.ACCEPT_ORDER.PROD_EX_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // 異常発生No.
        {
          prop: "aodProdExNo",
          label: t("resource.ACCEPT_ORDER.PROD_EX_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // クローズ
        {
          prop: "aodProdClose",
          label: t("resource.ACCEPT_ORDER.PROD_CLOSE_STATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ関連区分
        {
          prop: "aodMisumiKbnStr",
          label: t("resource.ACCEPT_ORDER.MSM_KBN"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

        //異常区分
        // {
        //   prop: "aodProdExKbnVal",
        //   label: t("resource.ACCEPT_ORDER.PRODUCT_EX_KBN"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },
      ],

      //*********注文用↓ */
      //注文状態
      orderStatusList: [
        {
          value: STR_ZERO,
          label: STR_AOB_ORDER_STATUS_NOT_ORDERED,
        },
        {
          value: STR_ONE,
          label: STR_AOB_ORDER_STATUS_ORDERED,
        },
      ],

      //注文データ
      orderForm: {
        aobQuoteNo: STR_EMPTY, // 採番台帳基本情報_見積No.
        aobProcKbn: STR_EMPTY, // プロセス区分
      },
      //*********注文用↑ */

      maxheight: t("widgetSize.ACCEPT_ORDER_INFO.PROCESS_ITEM_HEIGHT"),

      //現在選択されているセル
      currentCell: null,

      //カバー層のフラップ false:表示しない
      showFlag: false,
    };
  },

  computed: {
    filteredColumnsByTab() {
      return this.commonColumns.filter((column) => {
        return !(
          (
            (column.prop === "aodProdExKbnVal" &&
              this.activeName === "request") ||
            // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
            (column.prop === "aodMisumiKbnStr" &&
              this.activeName === "request") || //
            (column.prop === "aodMisumiKbnStr" && this.activeName === "send")
          )
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        );
      });
    },
  },

  props: {
    //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
    quoteType: {
      Type: Object,
    },
    //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
    procKbn: {
      Type: Object,
    },
    acceptData: {
      Type: Object,
    },
  },

  mounted() {
    //console.log("this.acceptData111--->" + JSON.stringify(this.acceptData));
    this.init(this.acceptData);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(window.innerHeight, 0, 0, 90);
    },

    //データの処理
    dataProcess(tableData, tabName) {
      //注文データ処理
      tableData.map((item) => {
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        item.aodProdExKbnVal = ShowMergeExKbn(
          item.aodProdExKbn,
          item.aodProdReceExKbn
        );
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        //表示値の変換
        let formatColumns = this.getFormatColumns(tabName);
        formatColumns.forEach((column) => {
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
          //item[column] = formatStringToCurrency(item[column]);

          //CNYの場合、2桁の小数を表示する
          if (column == "aodUPriceCNY" || column == "aodTotPriceCNY") {
            item[column] = formatStringToWeight(item[column]);
          } else {
            item[column] = formatStringToCurrency(item[column]);
          }
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
        });

        if (tabName === "order") {
          //仕入先納期
          item.aodSupDate = formatDateStrToString(item.aodSupDate);

          //仕入先
          item.aodSupCode = this.supplierCpyList.find(
            (it) => it.supCode === item.aodSupCode
          )?.supCodeAbb;

          //注文状態
          item.aodOrderStatus = this.orderStatusList.find(
            (it) => it.value === item.aodOrderStatus
          )?.label;

          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
          //大連工場の場合、加工単価(JPY)と小計(JPY)が「-」を表示する
          if (item.supFactoryKbn == FACTORY_KBN_DALIAN) {
            item.aodUPrice = "-";
            item.aodTotPrice = "-";
          } else {
            item.aodUPriceCNY = "-";
            item.aodTotPriceCNY = "-";
          }
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
        }
      });
    },

    // 製品異常
    // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    // rowClassName({ row }) {
    rowClassName({ row, column }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      if (
        row.aodProdExKbn != "-" &&
        row.aodProdExKbn != this.prodExKbnList[0].value
      ) {
        return "textColor";
      }

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      if (row.aodProdExKbnVal != NORMAL_PROD && this.activeName !== "request") {
        return "textColor";
      }
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    //表示値変換必要な列
    getFormatColumns(tabName) {
      let formatColumns = [];

      switch (tabName) {
        //注文
        case "order":
          //加工単価
          formatColumns.push("aodUPrice");
          //小計仕入金額
          formatColumns.push("aodTotPrice");
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
          //加工単価(CNY)
          formatColumns.push("aodUPriceCNY");
          //小計(CNY)
          formatColumns.push("aodTotPriceCNY");
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
          //数量
          formatColumns.push("aodProdQuantity");
          break;

        //検査室入荷
        case "checkRece":
          //数量
          formatColumns.push("aodProdQuantity");
          //合計
          formatColumns.push("okSumQty");
          //残
          formatColumns.push("residueSumQty");
          break;

        //運送
        case "trans":
          //数量
          formatColumns.push("aodProdQuantity");
          //合計
          formatColumns.push("okSumQty");
          //運送中
          formatColumns.push("ingSumQty");
          //残
          formatColumns.push("residueSumQty");
          break;

        //日本入荷
        case "rece":
          //数量
          formatColumns.push("aodProdQuantity");
          //合計
          formatColumns.push("okSumQty");
          //残
          formatColumns.push("residueSumQty");
          break;

        //出荷
        case "send":
          //数量
          formatColumns.push("aodProdQuantity");
          //合計
          formatColumns.push("okSumQty");
          //残
          formatColumns.push("residueSumQty");
          break;

        //請求
        case "request":
          //数量
          formatColumns.push("aodProdQuantity");
          //売価(個)
          formatColumns.push("aodUSetPrice");
          //合計
          formatColumns.push("aodTotSalesPrice");
          //請求済み数量
          formatColumns.push("requestedSumQty");
          //請求済み合計
          formatColumns.push("requestedTotalPrice");
          //請求残数量
          formatColumns.push("requestResidueSumQty");
          //請求残合計
          formatColumns.push("requestResidueTotalPrice");

          break;

        default:
          break;
      }

      return formatColumns;
    },

    //受注情報から注文情報の取得
    getOrderInfoFromAcceptInfo() {
      //console.log("this.acceptData--->" + JSON.stringify(this.orderForm));

      this.orderForm.aobProcKbn = this.procKbn;

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // searchOrderInfoFromAcceptInfo({
      //   acceptOrderBasicForm: this.orderForm,
      // })
      searchOrderInfoFromAcceptInfo({
        acceptOrderBasicForm: this.orderForm,
        quoteType: this.quoteType,
      })
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        .then((res) => {
          // console.log(
          //   "resresres: " + JSON.stringify(res.acceptOrderDetailInfoList)
          // );

          //タブ使用可能フラグ
          var isDisabled = res.acceptOrderDetailInfoList.every(
            (item) => item.supFactoryKbn !== FACTORY_KBN_DALIAN
          );

          this.editableTabs.forEach((tab) => {
            //日本工場の場合、検査室入荷と運送タブが使用不可に変更
            if (tab.name === "checkRece" || tab.name === "trans") {
              tab.disabled = isDisabled;
            }

            //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
            //金額調整の場合、検査室入荷、運送、日本入荷、納品タブが使用不可
            if (this.quoteType == STR_THREE) {
              if (
                tab.name === "checkRece" ||
                tab.name === "trans" ||
                tab.name === "rece" ||
                tab.name === "send"
              ) {
                tab.disabled = true;
              }
            }
            //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

            if (tab.name == "order") {
              tab.tableData = res.acceptOrderDetailInfoList;
            } else {
              tab.tableData = this.setTableData(
                res.processDic[tab.name],
                tab.name,
                tab.tableColumns
              );
            }

            this.dataProcess(tab.tableData, tab.name);

            //setColumnWidth(tab.tableColumns, tab.tableData);
          });
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    handleClick() {},

    // 初期化
    init(data) {
      this.showFlag = true;

      //受注情報の初期化
      this.infoInit(data);
    },

    //注文情報の初期化
    infoInit(data) {
      //基本情報のリスト取得
      getCommonInfoList()
        .then((res) => {
          //仕入先リスト
          this.supplierCpyList = res.supplierCpyList;
          //運送状態リスト
          this.transStatusList = res.transStatusList;
          //製品異常区分リスト
          this.prodExKbnList = res.prodExKbnList;

          //初期値の設定
          this.setInitValue(data);
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });
    },

    //初期値の設定
    setInitValue(data) {
      //受注No
      this.orderForm.aobQuoteNo = data.aobQuoteNo;

      //受注No.による受注詳細情報の取得
      this.getOrderInfoFromAcceptInfo();
    },

    //一覧データの設定
    setTableData(dtoList, tabName, tableColumns) {
      let tempList = dtoList;

      //追加列
      let columnsPropName = [];

      for (var i = 0; i < dtoList.length; i++) {
        var dateInfoList = dtoList[i].processDateInfoList;

        //日付関連情報がある場合
        if (dateInfoList.length > 0) {
          for (var j = 0; j < dateInfoList.length; j++) {
            //日付
            var tempDate = formatDateStrToString(
              dateInfoList[j].pdiProcessDate
            );

            //受注明細No.-プロセス区分
            var prodNoProcKbn = dateInfoList[j].pdiProdNoProcKbn;

            var propNameDateStr = tempDate;

            if (
              tabName === "checkRece" ||
              tabName === "rece" ||
              tabName === "send"
            ) {
              // if (tabName === "checkRece" || tabName === "rece") {
              //   propNameDateStr = propNameDateStr + "(入荷済み)";
              // }

              //数量の列prop
              var propNameQtyStr = tempDate + "_" + tabName + "_Qty";
              //数量の列の値
              var qtyValue = formatStringToCurrency(
                dateInfoList[j].pdiProcessQty
              );
              //NG数の列prop
              var propNameNgQtyStr = tempDate + "_" + tabName + "_NgQty";
              //NG数の列の値
              var ngQtyValue = formatStringToCurrency(
                dateInfoList[j].pdiProcessNgQty
              );

              //追加列に「receDate + "(入荷済み)"」がない場合
              if (
                !columnsPropName.some((columnsPropName) =>
                  columnsPropName.tempDate.includes(propNameDateStr)
                )
              ) {
                //列情報の追加
                columnsPropName.push({
                  tempDate: propNameDateStr,
                  propNameQty: propNameQtyStr,
                  propNameNgQty: propNameNgQtyStr,
                });

                //列データの追加
                //同じ行データの場合、列の値を表示し、以外の場合、0を表示する
                tempList = tempList.map((item) => ({
                  ...item,
                  [propNameQtyStr]:
                    item.aodProdNoProcKbn === prodNoProcKbn ? qtyValue : 0,
                  [propNameNgQtyStr]:
                    item.aodProdNoProcKbn === prodNoProcKbn ? ngQtyValue : 0,
                }));
              } else {
                //追加列に「receDate + "(入荷済み)"」がある場合
                //行データのindexを取得
                let indexToModify = tempList.findIndex(
                  (tempList) => tempList.aodProdNoProcKbn === prodNoProcKbn
                );

                //indexがある、データを更新する
                if (indexToModify !== -1) {
                  tempList[indexToModify][propNameQtyStr] = qtyValue;
                  tempList[indexToModify][propNameNgQtyStr] = ngQtyValue;
                }
              }
            } else {
              // if (tabName === "trans") {
              //   //状態
              //   var statusStr = this.transStatusList.find(
              //     (it) => it.value === dateInfoList[j].pdiProcessStatus
              //   )?.label;

              //   propNameDateStr = tempDate + "(" + statusStr + ")";
              // }

              //数量の列prop
              var propNameQtyStr = tempDate + "_" + tabName + "_Qty";
              //数量の列の値
              var qtyValue = formatStringToCurrency(
                dateInfoList[j].pdiProcessQty
              );

              //追加列に「receDate + "(入荷済み)"」がない場合
              if (
                !columnsPropName.some((columnsPropName) =>
                  columnsPropName.tempDate.includes(propNameDateStr)
                )
              ) {
                //列情報の追加
                columnsPropName.push({
                  tempDate: propNameDateStr,
                  propNameQty: propNameQtyStr,
                });

                //列データの追加
                //同じ行データの場合、列の値を表示し、以外の場合、0を表示する
                tempList = tempList.map((item) => ({
                  ...item,
                  [propNameQtyStr]:
                    item.aodProdNoProcKbn === prodNoProcKbn ? qtyValue : 0,
                }));
              } else {
                //追加列に「receDate + "(入荷済み)"」がある場合
                //行データのindexを取得
                let indexToModify = tempList.findIndex(
                  (tempList) => tempList.aodProdNoProcKbn === prodNoProcKbn
                );

                //indexがある、データを更新する
                if (indexToModify !== -1) {
                  tempList[indexToModify][propNameQtyStr] = qtyValue;
                }
              }
            }
          }
        }
      }

      //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
      //日付順に小さい値から大きい値まで表示
      columnsPropName.sort((a, b) => {
        const dateA = new Date(a.tempDate);
        const dateB = new Date(b.tempDate);

        return dateA - dateB;
      });
      //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

      if (columnsPropName.length > 0) {
        if (
          tabName === "checkRece" ||
          tabName === "rece" ||
          tabName === "send"
        ) {
          var labelVal = t("resource.ACCEPT_ORDER.RECEIVE_QTY");
          if (tabName === "send") {
            labelVal = t("resource.ACCEPT_ORDER.OUTBOUND_QTY");
          }

          for (var x = 0; x < columnsPropName.length; x++) {
            //データ追加
            tableColumns.push({
              label: columnsPropName[x].tempDate,
              children: [
                {
                  prop: columnsPropName[x].propNameQty,
                  label: labelVal,
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  headerAlign: "center",
                  align: "right",
                  class: "cell_txt_right",
                },
                {
                  prop: columnsPropName[x].propNameNgQty,
                  label: t("resource.ACCEPT_ORDER.NG_QTY"),
                  width: t("widgetSize.tableCommon.defaultWidth"),
                  headerAlign: "center",
                  align: "right",
                  class: "cell_txt_right",
                },
              ],
            });
          }
        } else {
          var labelVal = t("resource.ACCEPT_ORDER.TRANS_DATE_COUNT");
          if (tabName === "request") {
            labelVal = t("resource.ACCEPT_ORDER.REQUEST_DATE_COUNT");
          }

          let childrenList = [];

          for (var x = 0; x < columnsPropName.length; x++) {
            childrenList.push({
              prop: columnsPropName[x].propNameQty,
              label: columnsPropName[x].tempDate,
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              headerAlign: "center",
              align: "right",
              class: "cell_txt_right",
            });
          }

          //データ追加
          tableColumns.push({
            label: labelVal,
            children: [...childrenList],
          });
        }
      }

      return tempList;
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // var columnEditable = ["aodProdQuantity", "aodUSetPrice"];

      // if (
      //   columnEditable.includes(column.property) ||
      //   (column.property && column.property.toString().includes("newColumn"))
      // ) {
      //   //編集可能の背景色
      //   return "bg-cell-editable";
      // }

      if (
        (column.property === "aodProdQuantity" && row.aodProdQuantity < 0) ||
        (column.property === "aodTotPriceCNY" &&
          formatCurrencyToNumber(row.aodTotPriceCNY) < 0) ||
        (column.property === "aodTotPrice" &&
          formatCurrencyToNumber(row.aodTotPrice) < 0) ||
        (column.property === "okSumQty" &&
          formatCurrencyToNumber(row.okSumQty) < 0) ||
        (column.property === "aodTotSalesPrice" &&
          formatCurrencyToNumber(row.aodTotSalesPrice) < 0) ||
        (column.property === "requestedSumQty" && row.requestedSumQty < 0) ||
        (column.property === "requestedTotalPrice" &&
          formatCurrencyToNumber(row.requestedTotalPrice) < 0) ||
        (column.property === "requestResidueSumQty" &&
          row.requestResidueSumQty < 0) ||
        (column.property === "requestResidueTotalPrice" &&
          formatCurrencyToNumber(row.requestResidueTotalPrice) < 0)
      ) {
        return "txt-cell-editable_red";
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },
  },
};
</script>
<style scoped>
.editDatePicker {
  width: 100%;
  height: 17px;
  line-height: 0;
}

.el-table__body {
  height: 200px;
}
</style>
